import {createContext,useContext,useEffect} from 'react';
import {createPortal} from 'react-dom';

// Trusted React content, not a sandbox API. One header contribution per modal.
// Place this anywhere beneath ModalTemplate; actions stay live without Redux functions.
export const ModalHeaderContext=createContext(null);
export default function ModalHeader({title,subtitle,children}) {
 const context=useContext(ModalHeaderContext);
 const setHeading=context?.setHeading;
 useEffect(()=>{
  if(!setHeading)return undefined;
  setHeading({title,subtitle});
  return ()=>setHeading(null);
 },[setHeading,title,subtitle]);
 return context?(context.slot?createPortal(children,context.slot):null):children;
}
